<div class="main-content">
  <app-header
    [title]="'MACHINE_MODULES.HEADER_TITLE' | translate"
    [subtitle]="'MACHINE_MODULES.HEADER_SUBTITLE' | translate"
  />

  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container [iconName]="'list'" [iconColor]="'white'">
        <app-table
          [allValues$]="allMachines$"
          [type]="'machine_modules'"
          [hasChart]="false"
          [filters$]="machineFilters$"
          (selectedFilter)="onSelectedFilter($event)"
          (selectedPage)="onPageSelected($event)"
          [prevPage]="prevPage"
          [currentPage]="currentPage"
          [nextPage]="nextPage"
          [totalPages]="totalPages"
        />
      </app-icam-container>
    </div>
  </div>

  <div class="mt-4 mb-4">
    <app-back-button
      [linkText]="'MACHINE_MODULES.BACK_TO_USERS' | translate"
      (click)="goBack()"
    />
  </div>
</div>
<app-footer-copyright />
